import { UseFormReturn } from 'react-hook-form'
import { uploadPhoto } from '~/features/DocumentBasedRegistration/helpers'
import {
  FixButtonWrapper,
  FormWrapper,
} from '~/features/DocumentBasedRegistration/styled'
import { countriesOptions } from '~/shared/config/constants'
import { IdentityRecognitionFileEnum } from '~/shared/config/enums'
import { useTaxiparkQueryParams } from '~/shared/lib/useTaxiparkQueryParams'
import { Button } from '~/shared/ui/Buttons'
import { FormProvider, Select, PickPhotos } from '~/shared/ui/form'
import { FormValues } from './model'
import { TemplateWrapper } from './styled'

type FormProps = {
  onSuccess: (formValues: FormValues) => void
  form: UseFormReturn<FormValues>
}

const photoConfig = [
  {
    title: 'Первый разворот паспорта',
    type: IdentityRecognitionFileEnum.passport,
  },
  {
    title: 'Страница с регистрацией',
    type: 'registration_page',
  },
]

export function Form({ onSuccess, form }: FormProps) {
  const { taxiparkIdQuery } = useTaxiparkQueryParams()

  return (
    <FormProvider form={form} onSuccess={onSuccess}>
      <FormWrapper>
        <Select
          disabled={false}
          options={countriesOptions}
          name='citizenship'
          label='Гражданство'
          modalTitle='Гражданство'
          canSearch
        />
        <PickPhotos
          descriptions='Добавьте фотографию паспорта основного разворота и прописки'
          name='passportPhotos'
          fnUpload={(file: Blob) => uploadPhoto(file, taxiparkIdQuery)}
          multiple
          maxPhotos={photoConfig?.length}
          photoConfig={photoConfig}
        />
        <TemplateWrapper>
          <img src='/images/Pasport.png' alt='' />
        </TemplateWrapper>
        <FixButtonWrapper>
          <Button variant='limeFlooded' size='large' type='submit' fullWidth>
            Продолжить
          </Button>
        </FixButtonWrapper>
      </FormWrapper>
    </FormProvider>
  )
}
